import { InfoCircleOutlined } from '@ant-design/icons'
import { addCommasToNumber, DataItem, ReadableDifference, Texto } from '@gravitate-js/excalibrr'
import { Col, Row } from 'antd'
import moment from 'moment'
import React from 'react'
import { dateFormat } from '@constants/dateFormat'

export function LastReadingPopover({ tankRundownData, timezone }) {
  if (!tankRundownData) return null
  const lastReadingDate = moment(tankRundownData.as_of)
  const timeZoneSpecificReadingDate = moment(tankRundownData.measured_as_of)
  return (
    <>
      <Row flex justify='space-between' className='mb-4' span={24}>
        <Col>
          <DataItem label='Date & Time'>
            <b className='current-reading-date'>
              {moment(timeZoneSpecificReadingDate).format(dateFormat.DATE_TIME)} - {timezone}
            </b>
          </DataItem>
        </Col>
        <Col>
          <DataItem label='Volume'>
            <b className='current-volume text'>{addCommasToNumber(tankRundownData.measured_inventory)}</b>
          </DataItem>
        </Col>
      </Row>
      <Row className='mt-2 current-volume info-icon'>
        <Col span={2}>
          <InfoCircleOutlined className='current-volume info-icon' />
        </Col>
        <Col span={22}>
          <Texto weight='bold'>{`Estimated current volume, based on reading ${ReadableDifference(
            lastReadingDate
          )} ago.`}</Texto>
        </Col>
      </Row>
    </>
  )
}
